import { PlaceForm } from "@/components/forms/PlaceForm";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

export default function EditPlace() {
  const { id } = useParams();

  const { data: place, isLoading, error } = useQuery({
    queryKey: ["place", id],
    queryFn: async () => {
      const { data: session } = await supabase.auth.getSession();
      if (!session?.session?.user) throw new Error("No user session found");
      
      const { data, error } = await supabase
        .from("places")
        .select("*")
        .eq("id", parseInt(id!))
        .single();

      if (error) throw error;
      if (!data) throw new Error("Place not found");
      
      return data;
    },
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-lg font-semibold text-gray-900">Error loading place</h2>
          <p className="mt-1 text-sm text-gray-500">
            {error instanceof Error ? error.message : "Unknown error occurred"}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-semibold mb-6">Edit Place</h1>
      {place && <PlaceForm mode="edit" initialData={place} />}
    </div>
  );
}